import ReactDOM from 'react-dom/client';
import './tailwind.css';
import './variables.css';
import './index.css';
import './fonts.css';

// mock data
import './mock';

import { Provider } from 'react-redux';
import store from './redux/store';
import {
    createBrowserRouter,
    Navigate,
    RouterProvider,
} from 'react-router-dom';
import { NotFoundPage } from './pages/404';
import { Loading } from './components/loading';
import { Unauthorized } from './pages/unauthorized';
import { GeneralPage } from './pages/general';
import { ConfigProvider, ThemeConfig } from 'antd';
import { LoginPage } from './pages/auth/login';
import { LayoutType, SOURCE_PAGE } from './utils/enums';
import { RegisterPage } from './pages/auth/register';
import { DashboardPage } from './pages/dashboard';
import { IntegratedFoliosPage } from './pages/integrated_folios';
import { SubmittedFoliosPage } from './pages/submitted_folios';
import { UsersPage } from './pages/users';
import { TenantsPage } from './pages/tenants';

const config: ThemeConfig = {
    hashed: false,
    token: {
        fontFamily: 'Inter, serif',
        colorPrimary: '#088947',
    },
};

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
    {
        path: '/',
        element: <Navigate to="/dashboard" />,
    },
    {
        path: '/login',
        element: <Unauthorized page={<LoginPage />} />,
    },
    {
        path: '/register',
        element: <Unauthorized page={<RegisterPage />} />,
    },
    {
        path: '/dashboard',
        element: (
            <GeneralPage
                layout={LayoutType.ADMIN}
                page={<DashboardPage />}
                isPrivate
            />
        ),
        handle: {
            info: {
                title: 'Dashboard',
                description: 'Welcome to dashboard',
            },
            crumbs: [
                {
                    title: 'Home',
                    href: '/dashboard',
                },
            ],
        },
    },
    {
        path: '/integrated-folios',
        element: (
            <GeneralPage
                layout={LayoutType.ADMIN}
                page={<IntegratedFoliosPage source={SOURCE_PAGE.PMS} />}
                isPrivate
            />
        ),
        handle: {
            info: {
                title: 'Integrated Folios',
                description: 'Welcome to integrated Folios',
            },
            crumbs: [
                {
                    title: 'Home',
                    href: '/dashboard',
                },
                {
                    title: 'Integrated Folios',
                },
            ],
        },
    },
    {
        path: '/submitted-folios',
        element: (
            <GeneralPage
                layout={LayoutType.ADMIN}
                page={<SubmittedFoliosPage source={SOURCE_PAGE.PMS} />}
                isPrivate
            />
        ),
        handle: {
            info: {
                title: 'Submitted Folios',
                description: 'Welcome to submitted Folios',
            },
            crumbs: [
                {
                    title: 'Home',
                    href: '/dashboard',
                },
                {
                    title: 'Submitted Folios',
                },
            ],
        },
    },
    {
        path: '/integrated-checks',
        element: (
            <GeneralPage
                layout={LayoutType.ADMIN}
                page={<IntegratedFoliosPage source={SOURCE_PAGE.POS} />}
                isPrivate
            />
        ),
        handle: {
            info: {
                title: 'Integrated Checks',
                description: 'Welcome to integrated checks',
            },
            crumbs: [
                {
                    title: 'Home',
                    href: '/dashboard',
                },
                {
                    title: 'Integrated Checks',
                },
            ],
        },
    },
    {
        path: '/submitted-checks',
        element: (
            <GeneralPage
                layout={LayoutType.ADMIN}
                page={<SubmittedFoliosPage source={SOURCE_PAGE.POS} />}
                isPrivate
            />
        ),
        handle: {
            info: {
                title: 'Submitted Checks',
                description: 'Welcome to submitted Checks',
            },
            crumbs: [
                {
                    title: 'Home',
                    href: '/dashboard',
                },
                {
                    title: 'Submitted Checks',
                },
            ],
        },
    },

    {
        path: '/settings/users',
        element: (
            <GeneralPage
                layout={LayoutType.ADMIN}
                page={<UsersPage />}
                isPrivate
            />
        ),
        handle: {
            info: {
                title: 'Users',
                description: 'Welcome to the User page',
            },
            crumbs: [
                {
                    title: 'Home',
                    href: '/',
                },
            ],
        },
    },
    {
        path: '/settings/tenants',
        element: (
            <GeneralPage
                layout={LayoutType.ADMIN}
                page={<TenantsPage />}
                isPrivate
            />
        ),
        handle: {
            info: {
                title: 'Tenants',
                description: 'Welcome to the Tenant page',
            },
            crumbs: [
                {
                    title: 'Home',
                    href: '/',
                },
            ],
        },
    },
    {
        path: '*',
        element: <NotFoundPage />,
    },
]);

root.render(
    <ConfigProvider theme={config}>
        <Provider store={store}>
            <div className="App">
                <RouterProvider router={router} />
                <Loading />
            </div>
        </Provider>
    </ConfigProvider>
);
